import { PayerOrganizationRead } from 'src/common/external/bambi-api/bambiApi';

import { PricingFormBody } from './PricingFormBody';

export function PricingFormSection({
  showPayerLinkSwitch = true,
  selectedPayer,
  onPayerSelected,
}: {
  showPayerLinkSwitch?: boolean;
  selectedPayer: PayerOrganizationRead | null;
  onPayerSelected: (payer: PayerOrganizationRead | null) => void;
}) {
  return (
    <div className="flex flex-col gap-y-2">
      <PricingFormBody
        showPayerLinkSwitch={showPayerLinkSwitch}
        selectedPayer={selectedPayer}
        onPayerSelected={onPayerSelected}
      />
    </div>
  );
}
